import { render, staticRenderFns } from "./padronesPage.vue?vue&type=template&id=62d9cff0&"
import script from "./padronesPage.vue?vue&type=script&lang=js&"
export * from "./padronesPage.vue?vue&type=script&lang=js&"
import style0 from "./padronesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports